/**
 * Interface for the 'SearchFilterLabels' data
 */
export type SearchFilterLabelsEntity = SearchFilterLabelsNestedEntity | SearchFilterLabelsSimpleEntity;

export enum SearchFilterLabelsEntityType {
  simple = 'SIMPLE',
  nested = 'NESTED',
}

export interface SearchFilterLabelsBaseEntity {
  key: string;
  label: string;
  sortOrder?: SearchFilterLabelsSort;
}

export interface SearchFilterLabelsSimpleEntity extends SearchFilterLabelsBaseEntity {
  type: SearchFilterLabelsEntityType.simple;
  values: { [key: string]: string };
}

export interface SearchFilterLabelsNestedEntity extends SearchFilterLabelsBaseEntity {
  type: SearchFilterLabelsEntityType.nested;
  values: { key: string; external_id: string; label: string; root_path: string[]; inaccessible?: boolean }[];
}

export enum SearchFilterLabelsSort {
  fixed,
  alphabetic,
}
